import { yupResolver } from "@hookform/resolvers/yup";
import { useAxios } from "auth-sdk";
import { Form } from "@wayflyer/flyui";
import { RhfDateField, RhfTextField } from "@wayflyer/flyui-hook-form";
import type { FundingApplicationSchemas } from "api-types";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import * as Yup from "yup";

import { COMMON_MESSAGES } from "../../components/common-messages";
import type { NavigationProps } from "../../hooks/navigation-next/use-funding-application-navigation-next";

type PersonalCreditCheckDetailsProps = {
  navigationContext: NavigationProps;
  populatedData: any;
  customerDomain: string;
};

const personalCreditCheckDetailsSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  address1: Yup.string().required("House number is required"),
  address2: Yup.string().required("Street is required"),
  city: Yup.string().required("City is required"),
  postcode: Yup.string().required("Postcode is required"),
  country: Yup.string().required("Country is required"),
  dateOfBirth: Yup.string().required("Date of birth is required"),
});

export const PersonalCreditCheckDetails = ({
  navigationContext,
  populatedData,
  customerDomain,
}: PersonalCreditCheckDetailsProps) => {
  const intl = useIntl();
  const client = useAxios();
  const form = useForm({
    resolver: yupResolver(personalCreditCheckDetailsSchema),
    defaultValues: populatedData,
  });

  const onSubmit = async (data: FundingApplicationSchemas.DelphiApplicationRequestParams) => {
    await client.post(`/${customerDomain}/funding/api/personal-credit-check/`, data);
    if (navigationContext.nextPath) {
      navigationContext.navigate(navigationContext.nextPath);
    }
  };

  return (
    <Form
      onSubmit={form.handleSubmit(onSubmit)}
      primaryAction={{ content: intl.formatMessage(COMMON_MESSAGES.nextLabel) }}
      secondaryAction={{
        content: intl.formatMessage(COMMON_MESSAGES.backLabel),
        onAction: () => {
          if (navigationContext.previousPath) {
            navigationContext.navigate(navigationContext.previousPath);
          }
        },
      }}
    >
      <RhfTextField label="First name" name="firstName" form={form} />
      <RhfTextField label="Last name" name="lastName" form={form} />
      <RhfTextField label="House name/number" name="address1" form={form} />
      <RhfTextField label="Street" name="address2" form={form} />
      <RhfTextField label="City" name="city" form={form} />
      <RhfTextField label="Post code" name="postcode" form={form} />
      <RhfTextField label="Country" name="country" value="United Kingdom" disabled form={form} />
      <RhfDateField label="Date of birth" name="dateOfBirth" form={form} />
    </Form>
  );
};
